module.exports = __webpack_public_path__ + "static/img/Daniel_Talia_mobile.c001ae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel_Talia_mobile.jpg
// module id = WmbM
// module chunks = 0